module.exports = __webpack_public_path__ + "static/media/progress.787d4777.svg";